// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./_export');

$export($export.P + $export.R, 'Map', {toJSON: require('./_collection-to-json')('Map')});


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/modules/es7.map.to-json.js
// module id = 192
// module chunks = 20